<style lang="scss" scoped>
  @import "details";
  @media screen and (max-width: 640px){
    .container{
      width: 90% !important;
      font-size: 12px!important;
    }
    .text-lists {
      display: block!important;
    }
    .text-lists li {
      width: 100% !important;
    }
    .container h3.title {
      font-size: 20px !important;
    }
  }
</style>
<template>
  <div class="user-details">
    <section class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/user' }">用户中心</el-breadcrumb-item>
        <el-breadcrumb-item><router-link to="/user/project">项目订单</router-link></el-breadcrumb-item>
        <el-breadcrumb-item>项目订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <h3 class="title">项目订单确认<span :style="{fontSize: '14px', marginLeft: '20px', cursor: 'pointer'}"><a @click="viewContract">《服务协议》</a></span></h3>
      <ul class="text-lists">
        <li v-show="isHeadMan"><span>关联用户：</span>{{details.customerName}}</li>
        <li><span>订单创建者：</span>{{details.createUserName}}</li>
        <li><span>订单创建时间：</span>{{details.value.createTime | rTime}}</li>
        <li><span>实验基地：</span>{{details.baseName}}</li>
        <li><span>收货地址：</span>{{address}}</li>
      </ul>
      <div style="margin-top: 10px;">注：客户应自收到发票之日起3个月内支付费用，双方有其他约定的以另行约定为准</div>
      <el-table
        border
        class="mt20"
        :data="project">
        <el-table-column
          prop="no"
          label="订单编号">
        </el-table-column>
        <el-table-column
          label="订单金额（元）">
          <template slot-scope="scope">{{scope.row.amount | amount}}</template>
        </el-table-column>
        <el-table-column
          prop="orderStatusName"
          label="订单状态">
        </el-table-column>
        <el-table-column
          prop="settlementStatusName"
          label="结算状态">
        </el-table-column>
        <el-table-column
          label="配送状态">
          <template slot-scope="scope">{{scope.row.orderStatusName === '已完成' ? '已配送' : '未配送'}}</template>
        </el-table-column>
        <el-table-column
          prop="wayBillNo"
          label="运单号">
        </el-table-column>
        <el-table-column
          prop="estimatedDayDelivery"
          label="配送时间">
        </el-table-column>
      </el-table>
      <h3 class="title">项目信息</h3>
      <el-table
        border
        class="mt20"
        :data="project">
        <el-table-column
          prop="workOrderNo"
          label="项目工单号">
        </el-table-column>
        <el-table-column
          prop="name"
          label="项目名称">
        </el-table-column>
        <el-table-column
          prop="type"
          label="项目类型">
        </el-table-column>
        <el-table-column
          prop="workOrderStatusName"
          label="项目状态">
        </el-table-column>
        <el-table-column
          prop="estimatedDayDelivery"
          label="预计发货时间">
        </el-table-column>
      </el-table>
    </section>
  </div>
</template>

<script>
import { projectDetail } from '@/services/api.index'
export default {
  data () {
    return {
      orderTable: [],
      projectTable: [],
      details: {},
      project: [],
      address: '',
      isHeadMan: this.baseMethods.isHeadMan()
    }
  },
  created() {
    this.getDetails()
  },
  methods: {
    viewContract() {
      window.open(process.env.SHOP_URL + `/article/detail/14_0`)
    },
    getDetails () {
      const id = this.$route.query.id
      projectDetail(id).then(res => {
        this.details = res.data
        let value = res.data.value
        value.orderStatusName = this.baseMethods.orderStatus(res.data.userWebOrderStatus)
        value.settlementStatusName = this.baseMethods.settlementStatus(value.settlementStatus)
        value.shippedStatusName = this.baseMethods.shippedStatus(value.shippedStatus)
        value.workOrderStatusName = this.baseMethods.workOrderStatus(value.workOrderStatus)
        this.project = this.project.concat(value)
        this.address = `${value.raProvince}${value.raCity}${value.raCounty} ${value.raAddress}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/project_details.vue